// extracted by mini-css-extract-plugin
export default {"gridSticky":"styles_gridSticky__FMDH1"};